import Close from '@mui/icons-material/Close'
import { DialogContent, DialogTitle, IconButton, useTheme } from '@mui/material'
import dayjs from 'dayjs'
import { APPLICABLE_TO_ENTITY, MOMENT_FORMATS } from 'src/consumer/constants'
import { getOrdinalSuffix } from 'src/consumer/helpers/utilFunctions'
import { StyledPayoutListView } from './feeModelStyledComponents'

export default function FeeModelViewDetails({
  feeModel,
  entityFeeModel,
  showModelTitle = false,
  forMentor = false,
  closeDialog,
  renderInDrawer = false,
}) {
  const theme = useTheme()
  const content = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
      <ViewEntityFeeModel entityFeeModel={entityFeeModel} showModelTitle={showModelTitle} />
      <ViewFeeModel feeModel={feeModel} forMentor={forMentor} />
    </div>
  )

  if (renderInDrawer) {
    return content
  }

  return (
    <>
      <DialogTitle className="mb-2 d-flex justify-content-between align-items-center">
        {showModelTitle ? (
          <span>{entityFeeModel?.title || 'No Title'}</span>
        ) : (
          <span>
            {APPLICABLE_TO_ENTITY?.[entityFeeModel?.entityType]?.title || 'Others'} Fee Model
          </span>
        )}
        <IconButton onClick={closeDialog}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
    </>
  )
}

function ViewEntityFeeModel({ entityFeeModel }) {
  return (
    <div className="d-flex flex-column">
      <span>
        <strong>Validity: </strong>
        <span>
          {dayjs
            .utc(entityFeeModel?.applicableFrom)
            .local()
            .format(MOMENT_FORMATS.completeDateDetailsWithMonthShortForm)}{' '}
          -{' '}
          {entityFeeModel?.applicableTill
            ? dayjs
                .utc(entityFeeModel?.applicableTill)
                .local()
                .format(MOMENT_FORMATS.completeDateDetailsWithMonthShortForm)
            : 'Currenty Active'}
        </span>
      </span>
    </div>
  )
}
export function ViewFeeModel({ feeModel, hideHeading = false, forMentor }) {
  const hasComments = feeModel?.payoutList?.some((item) => !!item?.comment)

  return (
    <div className="d-flex flex-column gap-2">
      {!hideHeading && <h4>Model Details</h4>}
      <div className="d-flex flex-column gap-1">
        <StyledPayoutListView
          style={{ borderBottom: '1px solid black', marginBottom: '8px', fontWeight: 600 }}
          showCommentColumn={hasComments}
        >
          <span>Sessions</span>
          {/* <span>{forMentor ? 'Therapist Share' : 'Clinic Share'}</span> */}
          <span>Your Share</span>
          {hasComments && <span>Comment</span>}
        </StyledPayoutListView>
        {feeModel?.payoutList.map((payout, idx) => {
          const startId = payout?.startId || 1

          if (startId === payout?.endId) {
            return (
              <StyledPayoutListView key={idx} showCommentColumn={hasComments}>
                <span>{getOrdinalSuffix(startId)} Session</span>
                <span>{payout?.partnerFee}%</span>
                <div>{payout?.comment}</div>
              </StyledPayoutListView>
            )
          }

          if (!payout?.endId) {
            return (
              <StyledPayoutListView key={idx} showCommentColumn={hasComments}>
                <span>{getOrdinalSuffix(startId)} Session and Onwards</span>
                <span>{payout?.partnerFee}%</span>
                <div>{payout?.comment}</div>
              </StyledPayoutListView>
            )
          }

          if (!startId) {
            return (
              <StyledPayoutListView key={idx} showCommentColumn={hasComments}>
                <span>{getOrdinalSuffix(startId)} Session and Onwards</span>
                <span>{payout?.partnerFee}%</span>
                <div>{payout?.comment}</div>
              </StyledPayoutListView>
            )
          }

          return (
            <StyledPayoutListView key={idx} showCommentColumn={hasComments}>
              <span>
                {getOrdinalSuffix(startId)} {payout?.endId - startId > 1 ? 'to' : 'and'}{' '}
                {getOrdinalSuffix(payout?.endId)} Session
              </span>
              <span>{payout?.partnerFee}%</span>
              {/* {hasComments && <div>{payout?.comment}</div>} */}
              <div>{payout?.comment}</div>
            </StyledPayoutListView>
          )
        })}
      </div>
    </div>
  )
}
